var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24.002 24.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface_Filter",
    "data-name": "Interface / Filter",
    transform: "translate(-3.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.5,6.25a3.493,3.493,0,0,0-.154-1.483,1.4,1.4,0,0,0-.614-.614A3.5,3.5,0,0,0,24.251,4h-18a3.492,3.492,0,0,0-1.482.153,1.406,1.406,0,0,0-.614.614A3.5,3.5,0,0,0,4,6.25V7.287a3.01,3.01,0,0,0,.039.678,1.406,1.406,0,0,0,.169.406,3.011,3.011,0,0,0,.452.507L11.779,16a2.992,2.992,0,0,1,.451.506,1.408,1.408,0,0,1,.169.407,2.959,2.959,0,0,1,.038.667v6.688c0,1.206,0,1.809.254,2.172a1.406,1.406,0,0,0,.946.585c.438.065.978-.2,2.056-.744l1.125-.563a3.13,3.13,0,0,0,.842-.508,1.405,1.405,0,0,0,.325-.525,3.144,3.144,0,0,0,.077-.981V17.589a3.011,3.011,0,0,1,.039-.678,1.4,1.4,0,0,1,.169-.407,2.968,2.968,0,0,1,.447-.5l0,0,7.12-7.12a3,3,0,0,0,.451-.507,1.409,1.409,0,0,0,.169-.406A2.965,2.965,0,0,0,26.5,7.3Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDarkIcon);
export default __webpack_public_path__ + "static/media/filter-dark-icon.c9e1dc95e08376b895ee022f6a776239.svg";
export { ForwardRef as ReactComponent };